import { agriProductProvider, statisticProvider, storeProvider } from 'src/api';
import { IWfChartInstance, IWfChartData, IField, IRecord } from '../common';
import { IChartDataProvider, ChartDataBuilder } from './chart-data-provider';

const chartName = 'Số lượng nông sản trong kho';

let fields: IField[] = [
  { name: 'Tên', dataType: 'string', summary: 'none' },
  // { name: 'Số Lượng Kho 1', dataType: 'numeric', summary: 'none' },
  // { name: 'Số Lượng Kho 2', dataType: 'numeric', summary: 'none' },
];

async function loadData(instance: IWfChartInstance) {
  const [remains, agriProducts, stores] = await Promise.all([
    statisticProvider.getAgriProductRemaining(),
    agriProductProvider.getAllAgriProducts(true),
    storeProvider.getStores(),
  ]);

  fields = [
    { name: 'Tên', dataType: 'string', summary: 'none' },
  ];
  stores.forEach(s => {
    fields.push({
      name: s.name || '',
      dataType: 'numeric',
      summary: 'sum',
    });
  });
  fields.push({
    name: 'Tổng',
    dataType: 'numeric',
    summary: 'sum',
  });

  const records: IRecord[] = [];
  const productIds = new Set(remains.map(x => x.agriProductId));
  productIds.forEach(pId => {
    const prod = agriProducts.find(x => x.id === pId);

    const rdVals: any = [prod?.name || ''];
    let totalQuantiy = 0;
    stores.forEach(s => {
      const remainObj = remains.find(x => x.agriProductId === pId && x.storeId === s.id);
      totalQuantiy += remainObj?.quantity || 0;
      rdVals.push(remainObj?.quantity || 0);
    });
    rdVals.push(totalQuantiy); // add 'Tổng 2 Kho'
    records.push({
      values: rdVals
    });
  });

  const wfChartData: IWfChartData = { fields, records };
  ChartDataBuilder.sortIWfChartData(wfChartData, instance.settings.sortBy, instance.settings.sortDirection);

  if (instance.settings.chartType === 'horizontalBar') {
    wfChartData.chartJsData = ChartDataBuilder.decorBarChartData({
      chartData: wfChartData,
    });
  }
  else if (instance.settings.chartType === 'pie') {
    wfChartData.chartJsData = ChartDataBuilder.decorPieChartData(wfChartData);
  }
  return wfChartData;
}

export const AgriProductRemainingDataProvider: IChartDataProvider = {
  id: chartName,
  metadata: {
    name: chartName,
    category: 'Hàng Nông Sản',
    fieldNames: () => fields.map(x => x.name),
    unitList: ['KG'],
  },
  defaultSettings: {
    chartType: 'grid',
    showLabel: true,
    sortBy: 3,
    sortDirection: 'desc',
    dataProviderId: chartName,
    unit: 'KG',
    gridColumnWidths: [3, 2, 2, 2],
  },
  loadData,
};